import {
  Paper,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RemoveIcon from '@material-ui/icons/Close'
import LinkIcon from '@material-ui/icons/Link'
import Skeleton from '@material-ui/lab/Skeleton'

import useStyles from './styles/index.styles'

export default function ImageBoxSkeleton() {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Paper className={classes.item} elevation={4}>
      <div className={classes.parentDiv}>
        <div className={classes.thumbnail}>
          <Skeleton
            variant="circle"
            width={isSmall ? 40 : 60}
            height={isSmall ? 40 : 60}
          />
        </div>
        <div className={classes.details}>
          <Typography variant="subtitle1">
            <Skeleton variant="text" className={classes.skeletonImageBoxName} />
          </Typography>
          <Typography variant="caption">
            <Skeleton variant="text" className={classes.skeletonImageBoxSize} />
          </Typography>
        </div>
        <>
          <IconButton
            className={classes.linkIcon}
            size={isSmall ? 'small' : 'medium'}>
            <a href="'#'" target="'_blank'">
              <LinkIcon />
            </a>
          </IconButton>
          <IconButton size={isSmall ? 'small' : 'medium'}>
            <RemoveIcon />
          </IconButton>
        </>
      </div>
    </Paper>
  )
}
